import Scantag from '@/service/scantag'
import RequestUtils from './requestUtils.js'

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    getscantagabnormals(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Scantag.getscantagabnormals(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getscantags(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Scantag.getscantags(payload), {
        type: 'info',
        success,
        fail
      })
    },
    getfeedbacks(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Scantag.getfeedbacks(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getfeedback(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Scantag.getfeedback(payload), {
        type: 'info',
        success,
        fail
      })
    }
  }
}
